import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M53.7888 29.64L42.7488 50.904V63H37.2768V50.904L26.1888 29.64H32.2848L40.0128 46.008L47.7408 29.64H53.7888Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
